module.exports = __webpack_public_path__ + "img/235.19f05e78.png";